export default (callback, paramaters) => {
  if (typeof callback === "function") {
    callback.apply({}, paramaters);
  }
};
